import { z } from '@bonanza-social/toolkit/api';

export const ShopItemRewardSchema = z.enum([
  'CashReward',
  'FreeSpins',
  'Physical',
  'MysteryBox',
  'Wheel',
  'Scratcher',
]);

export const PurchasedItemRewardTypeSchema = z.enum([
  'Wheel',
  'Scratcher',
  'FreeSpins',
  'CashReward',
  'CoinsReward',
]);

export const ShopItemSale = z.object({
  id: z.number(),
  price: z.number(),
  percentage: z.number(),
  availableItems: z.number().optional(),
  displayAvailableItems: z.boolean(),
  label: z.string().optional(),
});

export const MysteryBoxItemDropSchema = z.object({
  weight: z.number(),
  type: PurchasedItemRewardTypeSchema,
  isTopPrize: z.boolean(),
  amount: z.number().optional(),
  coinsBackupValue: z.number().optional(),
  freeSpinsCoinValue: z.number().optional(),
  freeSpinsCount: z.number().optional(),
  freeSpinsGameName: z.string().optional(),
});

export const MysteryBoxConfigurationSchema = z.object({
  itemDrops: z.array(MysteryBoxItemDropSchema),
});

export const ShopItemSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: ShopItemRewardSchema,
  price: z.number(),
  description: z.string().optional(),
  thumbnail: z.string(),
  availableFrom: z.string().datetime().optional(),
  isBestValue: z.boolean(),
  sale: ShopItemSale.optional(),
  lastPurchasedAt: z.string().datetime().optional(),
  mysteryBoxConfiguration: MysteryBoxConfigurationSchema.optional(),
  isUnderMaintenance: z.boolean().optional(),
});

export const ShopItemsResponseSchema = z.object({
  items: z.array(ShopItemSchema),
});

export const PurchasedItemStatusSchema = z.enum(['Awarded', 'BackupAwarded']);

export const PurchasedItemSchema = z.object({
  type: PurchasedItemRewardTypeSchema,
  status: PurchasedItemStatusSchema,
  amount: z.number(),
  freeSpinsGameId: z.number().optional(),
  freeSpinsCoinValue: z.number().optional(),
  coinsBackupValue: z.number().optional(),
});

export const ShopItemPurchaseResponseSchema = z.object({
  purchasedItems: z.array(PurchasedItemSchema),
});

export const ShopSaleSchema = z.object({
  name: z.string(),
  id: z.number(),
  availableFrom: z.string().datetime(),
  fromCountdownEnabled: z.boolean(),
  availableTo: z.string().datetime(),
  toCountdownEnabled: z.boolean(),
  bannerImage: z.string().optional(),
});

export const ShopSalesResponseSchema = z.object({
  systemTime: z.string().datetime(),
  sales: z.array(ShopSaleSchema),
});

export const ShopSlotItemSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: ShopItemRewardSchema,
  price: z.number(),
  discountedPrice: z.number(),
  discountPercentage: z.number(),
  thumbnail: z.string(),
  freeSpinsGameIds: z.array(z.number()),
  freeSpinsCoinValue: z.number().optional(),
  isUnderMaintenance: z.boolean(),
  description: z.string().optional(),
  mysteryBoxConfiguration: MysteryBoxConfigurationSchema.optional(),
});

export const ShopSlotSchema = z.object({
  slotId: z.number(),
  item: ShopSlotItemSchema,
  cooldownEnd: z.string().datetime().optional(),
});

export const ShopSlotsResponseSchema = z.object({
  systemTime: z.string().datetime(),
  slots: z.array(ShopSlotSchema),
});

export const UserSettingsSchema = z.object({
  shouldShowPwa: z.boolean(),
  shouldShowCoinsShopInfo: z.boolean(),
  shouldShowCoinsPlayInfo: z.boolean(),
});
